import pl from "@locales/patient/programs_choice/pl.json";
import en from "@locales/patient/programs_choice/en.json";

export default {
  pl: pl,
  en: en,
};
